/**
 * @generated SignedSource<<c71e7293868803861ab33c3726b64ca2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "SettleImpulseResponse",
    "kind": "LinkedField",
    "name": "settleImpulse",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationSettleImpulseImplMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationSettleImpulseImplMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "78a922313fc8596d9c53095b4baab294",
    "id": null,
    "metadata": {},
    "name": "IntegrationSettleImpulseImplMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationSettleImpulseImplMutation(\n  $request: SettleImpulseRequestInput\n) {\n  settleImpulse(request: $request) {\n    status\n  }\n}\n"
  }
};
})();

node.hash = "b004a771734994667c3bfc07d18b7138";

module.exports = node;
